module.exports = __webpack_public_path__ + "media/images/flags/32/Lithuania-86703018969609a2fb8ef31877fc1226.png";